import React from 'react';
import './ConfirmacaoModal.css';

interface ConfirmacaoModalProps {
  isOpen: boolean;
  titulo: string;
  /** Descreve o RESULTADO da ação antes de executar (padrão do at-18). */
  descricao: React.ReactNode;
  rotuloConfirmar?: string;
  rotuloCancelar?: string;
  perigo?: boolean;
  carregando?: boolean;
  desabilitado?: boolean;
  onConfirmar: () => void;
  onCancelar: () => void;
}

const ConfirmacaoModal: React.FC<ConfirmacaoModalProps> = ({
  isOpen,
  titulo,
  descricao,
  rotuloConfirmar = 'Confirmar',
  rotuloCancelar = 'Cancelar',
  perigo = false,
  carregando = false,
  desabilitado = false,
  onConfirmar,
  onCancelar,
}) => {
  if (!isOpen) return null;

  return (
    <div className="pc-confirm-overlay" onClick={onCancelar}>
      <div className="pc-confirm-modal" onClick={(e) => e.stopPropagation()}>
        <h2 className="pc-confirm-titulo">{titulo}</h2>
        <div className="pc-confirm-descricao">{descricao}</div>
        <div className="pc-confirm-acoes">
          <button type="button" className="pc-btn pc-btn--secundario" onClick={onCancelar} disabled={carregando}>
            {rotuloCancelar}
          </button>
          <button
            type="button"
            className={`pc-btn ${perigo ? 'pc-btn--perigo' : 'pc-btn--primario'}${carregando ? ' pc-btn--carregando' : ''}`}
            onClick={onConfirmar}
            disabled={carregando || desabilitado}
            aria-busy={carregando}
          >
            {/* Carregando: o botão segue na cor dele, com o indicador girando, para não parecer travado. */}
            {carregando && <span className="pc-confirm-giro" aria-hidden="true" />}
            {carregando ? 'Processando...' : rotuloConfirmar}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmacaoModal;
